import UserWidget from './Container'
export default UserWidget


// WEBPACK FOOTER //
// ./src/modules/ControlBar/UserWidget/index.js